import { useContextSelector } from "use-context-selector";
import { ChatContext } from "../context/ChatContext";

export const useChat = () => {
  const chatOpen = useContextSelector(ChatContext, (context) => context.open);
  const handleChatOpen = useContextSelector(
    ChatContext,
    (context) => context.handleChatOpen
  );

  const messages = useContextSelector(
    ChatContext,
    (context) => context.messages
  );
  const loadMessages = useContextSelector(
    ChatContext,
    (context) => context.loadMessages
  );
  const concatMessages = useContextSelector(
    ChatContext,
    (context) => context.concatMessages
  );

  const files = useContextSelector(ChatContext, (context) => context.files);
  const addFiles = useContextSelector(
    ChatContext,
    (context) => context.addFiles
  );
  const removeFile = useContextSelector(
    ChatContext,
    (context) => context.removeFile
  );
  const clearFiles = useContextSelector(
    ChatContext,
    (context) => context.clearFiles
  );

  const fileInputRef = useContextSelector(
    ChatContext,
    (context) => context.fileInputRef
  );

  const notification = useContextSelector(
    ChatContext,
    (context) => context.notification
  );

  const handleSetNotification = useContextSelector(
    ChatContext,
    (context) => context.handleSetNotification
  );

  return {
    chatOpen,
    handleChatOpen,
    messages,
    loadMessages,
    concatMessages,
    files,
    addFiles,
    removeFile,
    clearFiles,
    fileInputRef,
    notification,
    handleSetNotification,
  };
};
